import { render, staticRenderFns } from "./CartEmpty.vue?vue&type=template&id=9cf8b2e8&scoped=true"
import script from "./CartEmpty.vue?vue&type=script&lang=js"
export * from "./CartEmpty.vue?vue&type=script&lang=js"
import style0 from "./CartEmpty.vue?vue&type=style&index=0&id=9cf8b2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf8b2e8",
  null
  
)

export default component.exports